import {Img, VerticalGauge} from "@varymadellc/my-weed-club-component-library";
import cx from 'classnames';
import {useState} from "react";
import {DiaryEntryType} from "../../types";
import {AiFillEdit} from "react-icons/ai";
import {Button, Card} from "@varymadellc/my-weed-club-component-library";
import {useRouter} from "next/router";
import {HashTagsCollection} from "@/components/HashTagsCollection";

export interface DiaryEntryLogProps {
    diaryEntries: DiaryEntryType[];
    search: string;
    editable?: boolean;
    hideHashTags?: boolean;
}

const mapVerbage = (value: string) => {
    switch (value.toUpperCase()) {
        case 'NONE':
            return 'UNKNOWN';
        default:
            return value;
    }
}

export default function DiaryEntryLog({diaryEntries, search, editable = false, hideHashTags = false}: DiaryEntryLogProps) {
    const navigation = useRouter();

    const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc');

    const [filter, setFilter] = useState<string>('entryDate');

    const searchDiaryEntry = (searchableDiaryEntries: any[] = []) => {
        typeof gtag !== 'undefined' && gtag('event', 'weed_log_search', {
            search
        });

        return searchableDiaryEntries.filter((diaryEntry: Record<string, any>) => {
            return String(diaryEntry.strain)?.toLowerCase().includes(search.toLowerCase())
                || String(diaryEntry.thoughts)?.toLowerCase().includes(search.toLowerCase())
                || String(diaryEntry.brand)?.toLowerCase().includes(search.toLowerCase())
        }).sort((a: any, b: any) => {
            const direction = sortDirection === 'asc' ? -1 : 1;

            if (a[filter] < b[filter]) {
                return direction;
            }

            if (a[filter] > b[filter]) {
                return -direction;
            }

            return 0;
        });
    }

    const sortBy = (type: string) => {
        if (filter === type) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        }

        setFilter(type);
    }

    return (
        <div className="w-full">
            <div className="lg:w-[500px]">
                <p>
                    Click link again to sort opposite
                </p>
                <Card inline={true} className="flex text-sm sm:text-base lg:flex-row !bg-primary !text-black mb-2">
                    <span className="ml-2">Sort by: &nbsp;</span>
                    <div className="flex-1">
                        <span className="underline" onClick={() => sortBy('entryDate')}>Date</span>
                    </div>
                    <div className="flex-1">
                        <span className="underline" onClick={() => sortBy('strain')}>Strain</span>
                    </div>
                    <div className="flex-1">
                        <span className="underline" onClick={() => sortBy('brand')}>Brand</span>
                    </div>
                    <div className="flex-1">
                        <span className="underline" onClick={() => sortBy('feel')}>Feel</span>
                    </div>
                    <div className="flex-1">
                        <span className="underline" onClick={() => sortBy('smell')}>Smell</span>
                    </div>
                    <div className="flex-1">
                        <span className="underline" onClick={() => sortBy('taste')}>Taste</span>
                    </div>
                    <div className="flex-1">
                        <span className="underline" onClick={() => sortBy('look')}>Look</span>
                    </div>
                </Card>
            </div>
            <div className="flex flex-col lg:flex-row lg:flex-wrap min-h-[400px] gap-4">
                {
                    searchDiaryEntry(diaryEntries).map((diaryEntry: any, index: number) => {
                        return (
                            <Card key={diaryEntry.entryDate}
                                  className="min-w-[49%] flex-1 overflow-hidden border-b-2 border-b-primary h-full">
                                <a id={`diary-entry-${diaryEntry.uuid}`}/>
                                <div className='flex flex-col w-full px-2 mb-2 lg:h-[200px]'>
                                    <div className="w-full flex flex-row">
                                        <div className="text-xs flex-1">
                                            {diaryEntry.isPublic ? 'Public' : 'Private'}
                                        </div>
                                        <div className="flex-2 text-end">
                                            {new Date(diaryEntry.entryDate).toLocaleDateString('en-us', {
                                                month: 'short',
                                                day: '2-digit',
                                                year: '2-digit',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                            })}
                                        </div>
                                    </div>
                                    <div className="flex flew-row h-[120px]">
                                        <div className="flex-1">
                                            <h2 onClick={() => editable && navigation.push(`/diary/${diaryEntry.uuid}`)}>
                                                <span
                                                    className={cx({'hover:pointer underline ': editable})}>{diaryEntry.strain}</span>
                                            </h2>
                                            <h4>
                                                &nbsp;&nbsp;&nbsp;&nbsp; <small>by:</small> {diaryEntry.brand}
                                            </h4>
                                        </div>
                                        <div className="flex flex-row justify-end items-center">
                                            <span>Quality: &nbsp;</span>
                                            {
                                                diaryEntry.worthy
                                                    ? <Img src="/imgs/thumbs-up.png" alt={diaryEntry.strain} className="w-[40px] h-[40px]"/>
                                                    : <Img src="/imgs/thumbs-down.png" alt={diaryEntry.strain} className="w-[40px] h-[40px]"/>
                                            }
                                        </div>
                                    </div>
                                    <div className="flex flex-row pb-2">
                                        <div className="flex-1">
                                            <small>Type: </small> {mapVerbage(diaryEntry.type).toLowerCase()}
                                        </div>
                                        <div className="flex flex-1 flex-row">
                                            <div className="flex flex-[9] flex-col w-full">
                                                <div className="flex flex-row w-full">
                                                    <small className="flex-1">Feel</small>
                                                    <small className="flex-1">Smell</small>
                                                    <small className="flex-1">Taste</small>
                                                    <small className="flex-1">Look</small>
                                                </div>
                                                <div className="flex w-full h-[30px]">
                                                    <VerticalGauge showLevel={true} className="flex-1"
                                                                   level={Math.min(100, diaryEntry.feel)}/>
                                                    &nbsp;
                                                    <VerticalGauge showLevel={true} className="flex-1"
                                                                   level={Math.min(100, diaryEntry.smell)}/>
                                                    &nbsp;
                                                    <VerticalGauge showLevel={true} className="flex-1"
                                                                   level={Math.min(100, diaryEntry.taste)}/>
                                                    &nbsp;
                                                    <VerticalGauge showLevel={true} className="flex-1"
                                                                   level={Math.min(100, diaryEntry.look)}/>
                                                </div>
                                            </div>
                                            {
                                                editable &&
                                                <div className="flex flex-1 w-full justify-end items-center p-2">
                                                    <Button className="bg-primary"
                                                            onClick={() => navigation.push(`/diary/${diaryEntry.uuid}`)}>
                                                        <AiFillEdit className="fill-black"/>
                                                    </Button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={cx("w-full h-[300px] overflow-x-hidden overflow-y-auto bg-black p-2")}>
                                    {diaryEntry.thoughts}
                                </div>
                                {
                                    !hideHashTags && <HashTagsCollection className="!h-[210px] overflow-y-scroll" uuid={diaryEntry.uuid}/>
                                }
                            </Card>
                        )
                    })
                }
            </div>
        </div>
    );
}